export interface IRegistrationState {
    isLoading: boolean;
    registrationData: IRegistrationDataResponse;
}

export const REQUEST_REGISTRATION_DATA = "REQUEST_REGISTRATION_DATA";
export const RECEIVE_REGISTRATION_DATA = "RECEIVE_REGISTRATION_DATA";

export interface IRequestRegistrationDataAction {
    type: typeof REQUEST_REGISTRATION_DATA;
}

export interface IReceiveRegistrationDataAction {
    type: typeof RECEIVE_REGISTRATION_DATA;
    registrationData: IRegistrationDataResponse;
}

export type RegistrationDataTypes = IRequestRegistrationDataAction | IReceiveRegistrationDataAction;

export interface IRegistrationDataResponse {
    personalInfo: any;
    addressInfo: any;
    billingInfo: any;
    PaymentMode: any;
    securityInfo: any;
    twoFactorMFA: any;
    NotificationPreference: any;
}
